// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__DKrqD","school":"ComboboxCoso_school__bVGjI","logo":"ComboboxCoso_logo__GjFnP","name":"ComboboxCoso_name__HvuUk"};